<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>clear</v-icon> Advertencia
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex md12>
            <v-textarea
              v-model="justificacion_rechazo"
              @input="encenderBandera()"
              class="v_card"
              rows="2"
              label="Justificación de la anulación"
              background-color="rgba( 117, 109, 194 ,0.4)"
              :rules="$validate(['required'])"
              required
              outline
              success
              clearable
            >
            </v-textarea>
          </v-flex>
        </v-layout>
        <h3>¿Desea anular el permiso?</h3>
        <br />
        <h4>Nota: Esta acción es irreversible</h4>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.prevent="close()"> Cancelar </v-btn>
        <v-btn
          color="success"
          @click.prevent="anularControlPermiso()"
          :loading="loading"
          :disabled="bandera_justificacion==false"
        >
          Anular
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
export default {
  mixins: [validate],
  props: ["item"],
  data() {
    return {
      dialog: false,
      permiso: {},
      loading: false,
      justificacion_rechazo: null,
      id: null,
      bandera_justificacion: false,
    };
  },
  mounted() {
    this.$bus.$on("openDialogAnularPermiso", (item) => {
      this.id = item.id_permiso;
      this.permiso = item.permiso;

      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.dialog = false;
      this.permiso = {};
      this.loading = false;
      this.justificacion_rechazo=null
      this.bandera_justificacion=false
      this.$bus.$emit("closeDialogAnularRRHH");
    },
    encenderBandera() {
      if (this.justificacion_rechazo) {
        this.bandera_justificacion = true;
        console.log(this.bandera_justificacion)
        return;
      }
      this.bandera_justificacion = false;
    },
    async anularControlPermiso() {
        this.loading = true;
        let user = this.$storage.get("user");
        let id_persona = null;
        if (this.$route.params.id !== undefined) {
          id_persona = parseInt(this.$route.params.id);
        }
        this.justificacion_rechazo= this.justificacion_rechazo.replace(/\n/g, " ");
        if (id_persona != "") {
          try {
            let respuesta = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_permiso_rrhh(${this.id},${id_persona},9,${user.id},'${this.justificacion_rechazo}')"){
                respuesta
                }
              }
              `,
            });
            let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_rrhh;

            let resps = resp.split("|");
            let correcto = resps[0];
            console.log(correcto);
            if (correcto === "1") {
              if (this.permiso.id_tipo_permiso == 24) {
                await this.devuelveDiasDescontados();
              }
              this.$confirm("El permiso fué anulado", () => {});
              this.$bus.$emit("closeDialog");
              this.close();
            } else {
              this.$confirm(resps[1], () => {});
              this.close();
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          try {
            let respuesta = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta:"select control.fn_solicita_anula_permiso(${this.id},9,${id_persona},${user.id},'')"){
                  respuesta
                  }
                }
                `,
            });
            let resp =
              respuesta.runQuery.respuesta[0].fn_solicita_anula_permiso;

            let resps = resp.split("|");
            let correcto = resps[0];

            if (correcto === "1") {
              this.$message.success();
              //this.$router.push('/personas')
            } else {
              this.$message.error(resps);
              // this.close()
            }
          } catch (error) {
            console.log(error);
          }
        }
        this.close();
      this.loading = false;
    },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id;
    },
    async devuelveDiasDescontados() {
      try {
        let user = this.$storage.get("user");
        let res = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta: "SELECT * FROM control.fn_anula_a_cuenta_vacacion(${this.id}, ${user.id})"){
                    respuesta
                  }
                }
              `,
        });
        res = res.runQuery.respuesta;
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    },
    async registerSeguimientoDetalle(id_permiso, id_persona, id_estado) {
      let seguimiento_detalle = {
        id_permiso,
        id_persona,
        id_estado,
      };

      await this.$service.graphql({
        query: `
					mutation add($seguimientoDetalle: NewSeguimientoDetalle!) {
						seguimientoDetalleAdd(seguimientoDetalle: $seguimientoDetalle) {
							id
						}
					}
				`,
        variables: {
          seguimientoDetalle: seguimiento_detalle,
        },
      });
      console.log("Seguimiento registrado");
      //location.reload()
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/AnularPermiso.vue